import React from 'react';
import { createRoot } from 'react-dom/client';

import RegisterApp from './containers/RegisterApp';

createRoot(document.getElementById('register-app')).render(
    <RegisterApp
        registerApiEndpoint = { REGISTER_API_ENDPOINT }
        termsUrl = { TERMS_URL }
    />
);